import React from 'react'
import { Provider } from 'react-redux'
import { Router } from "react-router-dom";
import { store, history } from './store'
import Layout from './layout/Layout'
import { StripeProvider } from 'react-stripe-elements';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import RootRoutes from './routes/RootRoutes'

ReactGA.initialize('UA-176419010-1');
ReactPixel.init('457106478399017');
ReactPixel.pageView();

history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);

  ReactPixel.pageView();
  window.scrollTo(0, 0);
});

const STRIPE_KEY = process.env.PUBLISHABLE_KEY

export default (props, railsContext) => {
  return () => (
    <Provider store={store}>
      <StripeProvider apiKey={STRIPE_KEY}>
        <Router history={ history }>
          <Layout>
            <RootRoutes/>
          </Layout>
        </Router>
      </StripeProvider>
    </Provider>
  )
}
